import React from "react";
import { motion } from "framer-motion";
import { Store, MapPin } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Section, SectionHead } from "@/components/landing/Section";
import { TrollArt } from "@/components/landing/TrollArt";
import { TROLLS } from "@/lib/trolls";

const MERCHANTS = TROLLS.filter((tr) => tr.category === "merchant");

export default function Merchants() {
  const { t, tl } = useLang();
  return (
    <Section id="merchants" testId="merchants-section" className="bg-paper/60 border-y border-line">
      <SectionHead kicker={t.merchants.kicker} title={t.merchants.title} body={t.merchants.body} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
        {MERCHANTS.map((m, i) => (
          <motion.div
            key={m.id}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06 }}
            data-testid={`merchant-card-${m.slug}`}
            className="journal-card p-6 flex gap-5 items-center"
          >
            <TrollArt troll={m} className="h-28 w-20 shrink-0" />
            <div className="min-w-0">
              <div className="inline-flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.14em] text-amber">
                <Store className="w-3.5 h-3.5" /> {t.merchants.types[m.merchant_type]}
              </div>
              <div className="font-display text-xl font-semibold text-ink mt-1">{m.name}</div>
              <div className="text-sm font-bold text-rowan">{tl(m, "epithet")}</div>
              <div className="text-sm text-ink-muted mt-2 inline-flex items-center gap-1.5">
                <MapPin className="w-3.5 h-3.5" /> {m.route_segment}
              </div>
              <div className="text-xs text-ink-muted mt-1 italic">{m.merchant_name || t.merchants.partnerSoon}</div>
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
